import React from 'react';
import styled from 'styled-components';

const ToolTipText = styled('span')({
  visibility: 'hidden',
  width: '180px',
  backgroundColor: '#3A4451',
  color: '#fff',
  borderRadius: '6px',
  padding: '8px 16px',
  position: 'absolute',
  fontSize: '14px',
  lineHeight: '20px',
  zIndex: 1000,
  bottom: '150%',
  left: '50%',
  marginLeft: '-89px',
  ':after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '50%',
    marginLeft: '-5px',
    borderWidth: '5px',
    borderStyle: 'solid',
    borderColor: '#3A4451 transparent transparent transparent',
  },
});

const ToolTip = styled('div')({
  position: 'relative',
  display: 'inline-block',
  ':hover span': {
    visibility: 'visible',
  },
});

const Tooltip: React.FC<any> = ({ children, toolTipText }) => (
  <ToolTip>
    {children}
    <ToolTipText>{toolTipText}</ToolTipText>
  </ToolTip>
);

export default Tooltip;
